import React from 'react';
import { RegisterLoginPage } from 'cccisd-laravel-nexus';

const Register = () => {
    const registerLoginProps = {
        registerProps: {
            role: 'learner',
            showPasswordFields: true,
            isRecaptchaRequired: true,
            validateAdditionalFields: values => {
                let errors = {};
                if (!values.first_name) {
                    errors.first_name = 'First name is required.';
                }
                if (!values.last_name) {
                    errors.last_name = 'Last name is required.';
                }
                return errors;
            },
        },
    };

    return <RegisterLoginPage {...registerLoginProps} />;
};

export default Register;
